import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

$.validator.addMethod('email',
    function (value, element) {
        // https://html.spec.whatwg.org/multipage/forms.html#e-mail-state-(type=email)
        // the original email validation follows HTML spec meaning that `person@space` is a legal email.
        return this.optional(element) ||
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.test(value);
    });

$.validator.addMethod('conditiondatavalidation', function (value, element) {
    const $current = $(element);
    const $parent = $current.closest('.checkbox');
    const $checkbox = $parent.find('.notification-setting');

    if ($checkbox.is(':checked')) {
        const type = $current.attr('data-val-conditiontype');
        switch (type) {
        case 'system.int32': {
            return /^\d+$/.test($current.val());
        }
        }
    }
    return false;
});

$.validator.unobtrusive.adapters.addBool('conditiondatavalidation', 'conditiondatavalidation');

const validate = $.fn.validate;
$.fn.validate = function (options) {
    if (options) {
        options.focusCleanup = true;
        options.onfocusin = function (element) {
            this.lastActive = element;

            // Hide error label and remove error class on focus if enabled
            if (this.settings.focusCleanup) {
                if (this.settings.unhighlight) {
                    this.settings.unhighlight.call(this, element, this.settings.errorClass, '');
                }
                this.hideThese(this.errorsFor(element));
            }
        };
        options.onkeyup = function () { };
    }

    return validate.bind(this)(options);
};

$.validator.addMethod('requiredif',
    (value, element, params) => {
        if (value !== '') return true;

        const $dependentControl = $(`#${params.dependentcontrolid}`);

        if (!$dependentControl) return true;

        const dependentElement = $dependentControl[0];

        if (!dependentElement) return true;

        let dependentElementValue;

        if (dependentElement.type === 'checkbox' || dependentElement.type === 'radio') {
            dependentElementValue = dependentElement.checked.toString();
        } else {
            dependentElementValue = dependentElement.val();
        }

        return params.comp === 'isequalto'
            ? (dependentElementValue.toUpperCase() !== params.value.toUpperCase())
            : (dependentElementValue.toUpperCase() === params.value.toUpperCase());
    });

$.validator.unobtrusive.adapters.add('requiredif',
    ['dependentcontrolid', 'comp', 'value'],
    options => {
        options.rules.requiredif = {
            dependentcontrolid: options.params.dependentcontrolid,
            comp: options.params.comp,
            value: options.params.value
        };
        options.messages.requiredif = options.message;
    });
